import z from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';

export const ssnSchema = z.object({
  [OnboardingFormFields.SSN]: z.string()
    .min(1, 'SSN is required')
    .refine(
    (ssn: string) => {
      const cleanedSSN = ssn.replace(/-/g, '').replace(/ /g, '');
      return cleanedSSN.length === 9;
    },
    { message: t('enErrors:ssn') }
  ),
});
